export const habitsquaresEmail = "habitsquaresapp@gmail.com";

export const habitSquaresFeatures = [
  "GitHub-style habit heatmaps",
  "Multiple habits",
  "Multiple Apple Reminders per habit",
  "Required vs optional reminders",
  "Daily completion summaries",
  "Widget-ready progress",
  "Local-first storage",
  "Built for iOS 17+",
];

export const habitSquaresTechStack = [
  "SwiftUI",
  "Core Data",
  "EventKit Reminders",
  "WidgetKit",
  "App Groups",
  "iOS 17+",
  "Future CloudKit sync",
];

export const habitSquaresCurrentRoadmapItems = [
  "Core habit tracking",
  "Reminder linking",
  "Heatmap completion logic",
  "Widget preview/support",
  "Local-first storage",
];

export const habitSquaresNextRoadmapItems = [
  "TestFlight feedback",
  "App Store launch",
  "iCloud sync",
  "More widget options",
  "More onboarding polish",
];
